import { useEffect, useState } from "react";
import { FilterValues } from "../../../data-model/filterValues";
import { buildOncologySubmissionFilterPayload } from "../utils/buildOncologySubmissionFilterPayload";
import {
  OncologySubmissionFilterPayload,
  ONCOLOGY_SUBMISSION_DEFAULT_ORDER_BY,
} from "../utils/oncologySubmissionFilterPayload";

export { ONCOLOGY_SUBMISSION_DEFAULT_ORDER_BY };
export type { OncologySubmissionFilterPayload };

export interface UseFilterPayloadReturn {
  filterPayload: OncologySubmissionFilterPayload | null;
  setFilterPayload: React.Dispatch<
    React.SetStateAction<OncologySubmissionFilterPayload | null>
  >;
}

export const useFilterPayload = (
  validFilters: FilterValues[],
  searchTerm: string,
  initialDataFetchingExecuted: boolean,
  dateFromStart: string,
  dateFromEnd: string,
  pageSize: number = 120,
): UseFilterPayloadReturn => {
  const [filterPayload, setFilterPayload] =
    useState<OncologySubmissionFilterPayload | null>(null);

  useEffect(() => {
    if (!initialDataFetchingExecuted) {
      setFilterPayload(null);
    } else {
      setFilterPayload(
        buildOncologySubmissionFilterPayload(
          validFilters,
          searchTerm,
          dateFromStart,
          dateFromEnd,
          pageSize,
        ),
      );
    }
  }, [
    validFilters,
    searchTerm,
    initialDataFetchingExecuted,
    dateFromStart,
    dateFromEnd,
    pageSize,
  ]);

  return {
    filterPayload,
    setFilterPayload,
  };
};
